import keycloak from "../../keycloak";
import axios from "axios";
import config from "../../config";


export async function getPythonExecutions() {
    try {
        let header = {
            headers: {
                'Content-Type': 'application/json', 'Authorization': 'Bearer ' + keycloak.token
            }
        }
        return (await axios.get(config.BACK_URL + "python/executions", header)).data;
    } catch (e) {
        return []
    }
}


export async function executePythonScript(data) {
    try {
        let header = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + keycloak.token
            }
        }
        return (await axios.post(config.BACK_URL + "python/execute", data, header)).data
    } catch (e) {

    }
}

export async function deletePythonExecution(execId) {
    try {
        let header = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + keycloak.token
            }
        }
        return (await axios.delete(config.BACK_URL + "python/executions?execId=" + encodeURIComponent(execId), header)).data
    } catch (e) {

    }
}